import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { isGtagConfigured, sendGtagPageView } from '../lib/gtag';

/**
 * Sends GA4 page_view on route changes when the Google tag is present.
 * Must live under the router (same tree as useLocation).
 */
export function GoogleTagRouteListener() {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    if (!isGtagConfigured()) return;
    const path = `${location.pathname}${location.search}`;
    if (lastPath.current === path) return;
    lastPath.current = path;
    sendGtagPageView(path);
  }, [location.pathname, location.search]);

  return null;
}
